import { type RefObject, useEffect, useRef } from 'react';

import { useAiBuilderChatComposerSignalState } from '../store';

/**
 * filePickerRequestId 신호를 소비해 숨겨진 file input을 클릭한다.
 * 패널이 닫혀 있으면 신호를 폐기하고, suppressed(choice/confirm 대기) 동안은 보류한다.
 */
export const useAiBuilderComposerFilePickerSignal = ({
  fileInputRef,
  panelOpen,
  suppressed,
}: {
  fileInputRef: RefObject<HTMLInputElement | null>;
  panelOpen: boolean;
  suppressed: boolean;
}) => {
  const { filePickerRequestId } = useAiBuilderChatComposerSignalState();
  const handledFilePickerRequestId = useRef(0);

  useEffect(() => {
    if (!panelOpen) {
      handledFilePickerRequestId.current = filePickerRequestId;
      return;
    }

    if (suppressed) return;
    if (filePickerRequestId <= 0) return;
    if (handledFilePickerRequestId.current === filePickerRequestId) return;

    handledFilePickerRequestId.current = filePickerRequestId;
    fileInputRef.current?.click();
  }, [fileInputRef, filePickerRequestId, panelOpen, suppressed]);
};
